// extracted by mini-css-extract-plugin
export var orderSummary = "_qn-0";
export var showMoreLessButton = "_qn-1";